export const entityTypeMap = {
  0: 'Any',
  1: 'Person',
  2: 'Company',
  3: 'Organisation',
  4: 'Vessel',
  5: 'Aircraft',
};
